import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { StockProducts, StockProductsType } from '../../types/slices/StockProductsType'

const initialState: StockProductsType =
{
    status: ApiStatus.FETCHED,
    stockproducts: [],
    totalRows: 0,
    stockproductSelected: {} as StockProducts,
    errorMessage: undefined,
    action: ''
}

const stockProductsSlice = createSlice({
    name: 'stockProductsSlice',
    initialState,
    reducers: {
        onFetchStockProducts(state, { payload }: { payload: StockProducts[] }) {
            state.status = ApiStatus.FETCHED
            state.stockproducts = payload
            state.errorMessage = undefined
        },
        onSetTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        },
        onSetSelectedStockProduct(state, { payload }: { payload: StockProducts }) {
            state.stockproductSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        setAction(state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectStockProductState = (state: RootState) => state.stockProductsSlice
export default stockProductsSlice.reducer
export const {
    onFetchStockProducts,
    onSetSelectedStockProduct,
    changeStatus,
    setAction,
    onSetTotalRows,
} = stockProductsSlice.actions
